import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { TournamentService } from '@/modules/tournament/api/services'
import { TOURNAMENT_QUERY_KEYS } from '@/modules/tournament/constants'
import type { paths } from '@/schema'

type CreateTournamentBody =
	paths['/api/admin/tournaments']['post']['requestBody']['content']['application/json']
type CreateTournamentResponse =
	paths['/api/admin/tournaments']['post']['responses']['201']['content']['application/json']

interface UseMutationCreateTournamentOptions {
	onSuccess?: () => void
	onError?: (error: Error) => void
}

const useMutationCreateTournament = (
	options?: UseMutationCreateTournamentOptions,
) => {
	const queryClient = useQueryClient()
	const navigate = useNavigate()

	return useMutation<CreateTournamentResponse, Error, CreateTournamentBody>({
		mutationFn: (body) => TournamentService.createTournament(body),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: TOURNAMENT_QUERY_KEYS.TOURNAMENTS.ALL,
			})
			toast.success('สร้างทัวร์นาเมนต์สำเร็จ')
			if (options?.onSuccess) {
				options.onSuccess()
			} else {
				navigate('/operator/tournaments')
			}
		},
		onError: (error) => {
			toast.error('สร้างทัวร์นาเมนต์ล้มเหลว')
			options?.onError?.(error)
		},
	})
}

export default useMutationCreateTournament
